// extracted by mini-css-extract-plugin
module.exports = {"tourStep":"tourStep--x33Y6","tourTitle":"tourTitle--nUMOE","tourDesc":"tourDesc--chjZ9","tourBtnBox":"tourBtnBox--fDX5M","ant-btn":"ant-btn--81Uen"};